import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute
 *  - Always requires authentication (redirects to /login if not logged in).
 *  - If requireCharacter is true (default), also requires a selected character
 *    (redirects to /characters if authenticated but no character selected).
 *  - If requireAdmin is true, also requires user.isAdmin
 *    (redirects to /game if authenticated but not admin).
 */
const ProtectedRoute = ({ children, requireCharacter = true, requireAdmin = false }) => {
  const { isAuthenticated, hasCharacter, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireCharacter && !hasCharacter) {
    return <Navigate to="/characters" replace />;
  }

  if (requireAdmin && (!user || !user.isAdmin)) {
    return <Navigate to="/game" replace />;
  }

  return children;
};

export default ProtectedRoute;
